import { Component } from '@angular/core';
import { Validators } from '@angular/forms';
import { GenericCrudAddComponent } from 'src/app/libs/components/generic-crud/generic-crud-add.component';
import { ProductBatchState } from 'src/app/models';

@Component({
    selector: 'app-product-batch-states-add',
    templateUrl: './product-batch-states-add.component.html',
    styleUrl: './product-batch-states-add.component.sass',
    standalone: false
})
export class ProductBatchStatesAddComponent extends GenericCrudAddComponent<ProductBatchState> {
  override resource = this.api.resources.product.productBatchStates;
  initFormGroup() {
    const form = this.fb.group({
      name: ['', Validators.required],
      color: ['', Validators.required],
      companyId: [this.api.auth.userValue?.lastCompanyId],
      excludeFromStockForecast: [false],
      excludeFromValuedInventory: [false],
      isBlockedForOperations: [false],
    });
    return form;
  }

  protected override async mapFormEntity(): Promise<Partial<ProductBatchState>> {
    const v = { ...this.form!.value } as Partial<ProductBatchState>;
    return { ...v, color: v.color ?? '' };
  }
}
